import React from 'react';

export const Loading = () => {
    return(
        <div class="loader-container">
                        <div className="loader">
                             <img src='https://firebasestorage.googleapis.com/v0/b/hrceramics-ff4ff.appspot.com/o/assets%2Floader.gif?alt=media&token=ef756efe-57b3-4932-9fa9-2808cbc4710c' alt='Loader' /> 
                        </div>
                    </div>
    );
};